export class SensorPoint {
    constructor(id, location, value) {
        this.id = id;
        this.location = location;
        this.value = value;
    }
}

export class SensorLocation {
    constructor(coord) {
        this.type = "Point";
        this.coordinates = coord;
    }
}

export class PolygonPoint {
    constructor(coord) {
        this.x = coord[0];
        this.y = coord[1];
        this.type = "Point";
        this.coordinates = coord;
    }
}


// WEBPACK FOOTER //
// ./src/classes/index.js